import { Box, Button, Grid, Typography } from '@mui/material'
import React from 'react'
import RadioBoxGroup from '../../components/RadioButtons/RadioBoxGroup'
import ToggleSwitch from '../../components/ToggleSwitch/ToggleSwitch'
import CustomDepartmentSelect from './CustomDepartmentSelect'

const MemberProfileSettings = () => {
  const addMemberOptions = [
    'User ', 'Manager', 'Viewer',
  ]
  const inputStyle = {
    height: '46px', borderRadius: '50px',
    backgroundColor: '#fff',
    fontSize: '13px',
  };
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, }}>
        <Typography sx={{ fontSize: {xl: '16px' , lg: '14px' , md: '14px' , sm: '14px' , xs: '14px'}, fontWeight: '600', color: '#1A1F36', }}>Able to track time</Typography> <ToggleSwitch />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, }}>
        <Typography sx={{ fontSize: {xl: '16px' , lg: '14px' , md: '14px' , sm: '14px' , xs: '14px'}, fontWeight: '600', color: '#1A1F36', }}>Able to modify time</Typography> <ToggleSwitch />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, }}>
        <Typography sx={{ fontSize: {xl: '16px' , lg: '14px' , md: '14px' , sm: '14px' , xs: '14px'}, fontWeight: '600', color: '#1A1F36', }}>Add member to all new projects</Typography> <ToggleSwitch />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
        <Typography sx={{ fontSize: {xl: '16px' , lg: '14px' , md: '14px' , sm: '14px' , xs: '14px'}, fontWeight: '600', color: '#1A1F36', }}>Use shifts to set work allowance limits</Typography>
        <RadioBoxGroup
          options={['Yes', 'No']}
          defaultValue="Yes"
          row={true}
        /></Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 2, }}>
        <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#64748B', }}>Add as:</Typography>  <CustomDepartmentSelect inputStyle={inputStyle} selectedPlaceholder="Select" modalSearchplaceHolder="Search" initialOptions={addMemberOptions} showAddOption={false} searchBox={false} />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 2 }}>
        <Typography sx={{ fontSize: {xl: '16px' , lg: '14px' , md: '14px' , sm: '14px' , xs: '14px'}, fontWeight: '600', color: '#1A1F36', }}>Allowed apps</Typography>
        <RadioBoxGroup
          options={['All Apps', 'Desktop Only']}
          defaultValue="Yes"
          row={true}
        /></Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 2 , flexWrap: {xl: 'nowrap' , lg: 'nowrap' , md: 'wrap' , sm: 'wrap' , xs: 'wrap'}}}>
        <Typography sx={{ fontSize: {xl: '16px' , lg: '14px' , md: '14px' , sm: '14px' , xs: '14px'}, fontWeight: '600', color: '#1A1F36', }}>Idle timeout</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: {xl: 2 , lg: 2 , md: 1 , sm: 1 , xs: 1}}}>
          <Typography sx={{ fontSize: '14px', fontWeight: '500', color: '#0076FE', }}>Customize Idle timeout</Typography>
          <RadioBoxGroup
            options={['5m', '10m', '15m', '20m', '30m', '1h',]}
            defaultValue="Yes"
            row={true}
            
          /></Box>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 2 }}>
        <Typography sx={{ fontSize: {xl: '16px' , lg: '14px' , md: '14px' , sm: '14px' , xs: '14px'}, fontWeight: '600', color: '#1A1F36', }}>Keep idle time</Typography>

        <RadioBoxGroup
          options={['Prompt', 'Always', 'Never',]}
          defaultValue="Yes"
          row={true}
        />
      </Box>

      <Grid item size={{ xs: 12, md: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
        <Button
          variant="outlined"
          color="inherit"
          sx={{
            fontSize: '14px',
            borderRadius: '50px',
            background: '#fff',
            border: '1px solid #9095A1',
            color: '#9095A1',
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          sx={{
            fontSize: '14px',
            borderRadius: '50px',
            background: '#0076FE',
            border: '1px solid #0076FE',
            color: '#fff',
          }}
        >
          Save & Update
        </Button>
      </Grid>

    </>
  )
}

export default MemberProfileSettings
